var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.anchoPantalla < 992)?_c('VotosPorPartidoPoliticoMovil',{staticClass:"d-lg-none"}):_c('VotosPorPartidoPoliticoEscritorio',{staticClass:"d-lg-block d-none"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }